import { combineReducers } from '@reduxjs/toolkit';

import { listSlice } from './listSlice';
import { registrationSlice } from './registrationSlice';
import { editSlice } from './editSlice';
import { contractListSlice } from './contractListSlice';
import { contractRegistrationSlice } from './contractRegistrationSlice';
import { contractEditSlice } from './contractEditSlice';

export const customerReducer = combineReducers({
  /** 顧客一覧の状態 */
  list: listSlice.reducer,
  /** 顧客登録の状態 */
  registration: registrationSlice.reducer,
  /** 顧客編集の状態 */
  edit: editSlice.reducer,
  /** 契約一覧の状態 */
  contractList: contractListSlice.reducer,
  /** 契約登録の状態 */
  contractRegistration: contractRegistrationSlice.reducer,
  /** 契約編集の状態 */
  contractEdit: contractEditSlice.reducer,
});
